var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-087259d3\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./PingPong.vue")
}
var normalizeComponent = require("!../../../vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./PingPong.vue"
import __vue_script__ from "!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./PingPong.vue"
/* template */
import __vue_template__ from "!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-087259d3\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../vue-loader/lib/selector?type=template&index=0!./PingPong.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-087259d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue-loading-spinner/src/components/PingPong.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-087259d3", Component.options)
  } else {
    hotAPI.reload("data-v-087259d3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/PingPong.vue
// module id = S2v/
// module chunks = 0